import React, { useEffect } from 'react'
import '../../assets/theme/theme.less'
import { LayoutComponent as Layout, ButtonComponent as Button } from '../../components'
import { Row, Col } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { getAutomacoes } from '../../redux/slices/automacaoOperacaoSlice'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as iconPlus } from '../../assets/img/plus.svg'
import AutomacoesTable from './automacoesTable'

const Automacoes = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isLoading, automacoes } = useSelector((state) => state.automacaoOperacao)

    useEffect(() => {
        dispatch(getAutomacoes({ limit: 100 }))
    }, [dispatch])

    return (
        <Layout width>
            <Row>
                <Col md={24}>
                    <div className="d-flex justify-between align-center">
                        <div>
                            <h1 className="title page-title">Automações</h1>
                            <p className="tx-gray mt-10">
                                Configure a liquidação automática diária por produto.
                            </p>
                        </div>
                        <div style={{ width: 220 }}>
                            <Button
                                type="primary"
                                active
                                icon={iconPlus}
                                htmlType="button"
                                onClick={() => navigate('/automacoes/nova')}
                            >
                                Nova Automação
                            </Button>
                        </div>
                    </div>
                </Col>
                <Col md={24} className="mt-25">
                    <AutomacoesTable
                        loading={isLoading}
                        automacoes={automacoes}
                        onView={(id) => navigate(`/automacoes/${id}`)}
                    />
                </Col>
            </Row>
        </Layout>
    )
}

export default Automacoes
